import React from 'react';
import InfoTooltip from 'components/shared/InfoTooltip';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { LabeledCheckbox } from 'components/shared/checkbox';

const FillerWords = ({ content, onChange }) => {
  return (
    <LabeledCheckbox
      className="EditorElement-options mt-20 w-fc"
      checkBoxClassName="va-m h-18 w-18 mr-12-imp"
      label={
        <>
          <Text variant={TEXT_VARIANTS.BODY}>
            {t('automated_analysis.filler_words.usage')}
          </Text>
          <InfoTooltip
            className="pl-4 mt-4 tooltip-fixedWidth c-gray-light"
            tooltip={t('automated_analysis.filler_words.tooltip')}
          />
        </>
      }
      onChange={e =>
        onChange({
          question_automated_analysis_filler_words_enabled: e.target.checked,
          automated_analysis_filler_words_enabled: e.target.checked,
        })
      }
      checked={content.automated_analysis_filler_words_enabled}
    />
  );
};

export default FillerWords;
